module.exports = __webpack_public_path__ + "static/media/default_avatar.ec75044f.png";